
import React, { useState, useEffect } from "react";
import css from './VoiceSearch.module.css';
import classNames from "classnames";
import IconCollection from "../../IconCollection/IconCollection";

function VoiceSearch({ onVoiceSearch, className }) {
    const SpeechRecognition = typeof window !== 'undefined' ? window.SpeechRecognition || window.webkitSpeechRecognition : null;

    const [isListening, setIsListening] = useState(false);
    const [note, setNote] = useState("");

    useEffect(() => {
        if (!SpeechRecognition) {
            console.warn("Browser does not support Speech Recognition");
            return;
        }

        const mic = new SpeechRecognition();
        mic.continuous = true;
        mic.interimResults = true;
        mic.lang = "en-US";

        const handleListen = () => {
            if (isListening) {
                mic.start();
                mic.onend = () => {
                    console.log("Mic restarted");
                    mic.start();
                };
            } else {
                mic.stop();
                mic.onend = () => {
                    console.log("Mic stopped");
                };
            }

            mic.onstart = () => {
                console.log("Mic is on");
            };

            mic.onresult = (event) => {
                const transcript = Array.from(event.results)
                    .map(result => result[0])
                    .map(result => result.transcript)
                    .join("");
                console.log(transcript, 'trans')
                onVoiceSearch(transcript);
                setNote(transcript);
            };

            mic.onerror = (event) => {
                console.error("Mic error:", event.error);
            };
        };

        handleListen();

        return () => {
            mic.stop();
            mic.onend = null;
            mic.onstart = null;
            mic.onresult = null;
            mic.onerror = null;
        };
    }, [isListening, SpeechRecognition]);

    const handleButtonClick = () => {
        setIsListening(prevState => !prevState);
    };

    if (!SpeechRecognition) {
        return null;
    }

    return (
        <div className={classNames(className, css.container)}>
            <button className={css.btn} type="button" onClick={handleButtonClick}>
                {isListening ? (
                    <div className={css.listeningContainer}>
                        <div id="speech" className={css.speechButton}>
                            <div className={css.pulseRing}></div>
                            <svg fill="#000000" width="24px" height="24px" viewBox="-0.105 0 0.72 0.72" xmlns="http://www.w3.org/2000/svg"><path d="M0.252 0.504a0.144 0.144 0 0 0 0.144 -0.144V0.144a0.144 0.144 0 1 0 -0.288 0V0.36a0.144 0.144 0 0 0 0.144 0.144" /><path d="M0.504 0.36V0.288a0.036 0.036 0 1 0 -0.072 0V0.36a0.18 0.18 0 1 1 -0.36 0V0.288a0.036 0.036 0 1 0 -0.072 0V0.36a0.252 0.252 0 0 0 0.215 0.249l0.001 0V0.648H0.108a0.036 0.036 0 1 0 0 0.072h0.288a0.036 0.036 0 1 0 0 -0.072H0.288v-0.039c0.123 -0.018 0.216 -0.123 0.216 -0.249z" /></svg>
                        </div>
                    </div>
                ) : (
                    <div className={css.listeningContainer}>
                        <div id="speech" className={classNames(css.speechButton, css.speechButtonBefore)}>
                            <span className={css.speechMicBefore}>
                               <IconCollection name="speechMic"/>

                            </span>
                        </div>
                    </div>

                )}
            </button>
        </div>
    );
}

export default VoiceSearch;
